import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import request from '../utils/request';

function Buy() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (searchParams.get('paid') === '1') {
      alert('购买成功！6个牵线名额已到账');
      navigate('/buy', { replace: true });
    }
  }, [searchParams, navigate]);

  const handleBuy = async () => {
    setSubmitting(true);
    try {
      const res = await request({
        url: '/api/buy/create',
        method: 'POST'
      });
      if (res.data.payUrl) {
        window.location.href = res.data.payUrl;
      } else {
        alert(res.data.error || '创建订单失败');
      }
    } catch (err) {
      const msg = err.response?.data?.error || err.message || '购买失败';
      alert(typeof msg === 'string' ? msg : '购买失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container">
      <div className="card" style={{ textAlign: 'center' }}>
        <h2 style={{ color: '#ff6b6b' }}>会员套餐</h2>
        <p style={{ fontSize: 36, fontWeight: 'bold', margin: '24px 0' }}>
          ¥399
        </p>
        <p style={{ color: '#666' }}>6个牵线名额 · 有效期6个月</p>
      </div>

      <div className="card">
        <h3>会员权益</h3>
        <ul style={{ marginTop: 12, lineHeight: 2 }}>
          <li>✓ 获得6个牵线名额</li>
          <li>✓ 有效期6个月</li>
          <li>✓ 可主动发起牵线</li>
          <li>✓ 查看对方联系方式</li>
        </ul>
      </div>

      <button 
        className="btn btn-primary"
        onClick={handleBuy}
        disabled={submitting}
        style={{ marginTop: 24 }}
      >
        {submitting ? '创建订单中...' : '立即购买'}
      </button>

      <p style={{ 
        textAlign: 'center', 
        color: '#999', 
        marginTop: 16,
        fontSize: 14 
      }}>
        购买后名额自动到账，可在"我的"中查看
      </p>

      <button 
        className="btn btn-secondary"
        onClick={() => navigate('/')}
        style={{ marginTop: 12 }}
      >
        返回首页
      </button>
    </div>
  );
}

export default Buy;